import React from 'react';
import {
  fetchEnterpriseCaseCountForSearchSnippet,
  fetchEnterpriseDecisions,
  CaseDataType,
} from '../../../../../enterprise/enterprise.api';
import { EnterpriseDecisions } from '../../../../../enterprise/enterprise.types';

type State = {
  juridictions: Array<EnterpriseDecisions['juridictions'][0]>;
  villes: Array<EnterpriseDecisions['villes'][0]>;
  caseData: CaseDataType['caseData'] | undefined;
};

type Props = {
  siren: string;
  children: (props: State) => React.ReactNode;
};

export class EnterpriseSnippetFetcher extends React.Component<Props, State> {
  state: State = { juridictions: [], villes: [], caseData: undefined };

  isMounted = false;

  componentDidMount() {
    this.isMounted = true;
    this.loadData(this.props.siren);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.siren !== prevProps.siren) {
      this.loadData(this.props.siren);
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  loadData(siren: string) {
    fetchEnterpriseDecisions(siren).then(({ juridictions, villes }) => {
      if (this.isMounted) {
        this.setState({ juridictions, villes });
      }
    });

    fetchEnterpriseCaseCountForSearchSnippet(siren).then(response => {
      const { caseData } = response.data;
      if (
        caseData.years.length &&
        caseData.caseCounts.some(item => item > 0) &&
        this.isMounted
      ) {
        this.setState({ caseData });
      }
    });
  }

  render() {
    const { children } = this.props;
    return children(this.state);
  }
}
